// src/routes/AppRoutes.js
// Import necessary modules and components
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/login/login";
import Main from "../pages/main";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import Material from "../pages/material/material";
import Inbond from "../pages/inbond/inbond";
import Addinbond from "../components/inbond/addinbond";
import Exbond from "../pages/exbond/exbond";
import Addexbond from "../components/exbond/addexbond";
import Calculator from "../pages/calculator/calculator";
import Sections from "../pages/sections/sections";
import Dutyspace from "../pages/dutyspace/dutyspace";
import Customer from "../pages/customer/customer";
import Dispatch from "../pages/dispatch/dispatch";
import AddDispatch from "../components/dispatch/adddispatch";
import Dashboard from "../pages/dashboard/dashboard";
import EditInBond from "../components/inbond/editinbond";
import Editexbond from "../components/exbond/editexbond";
import EditDispatch from "../components/dispatch/editdispatch";

// Define all application routes
const AppRoutes = () => (
  <Routes>
     {/* Public Route: Login page (accessible without authentication) */}
    <Route path="/login" element={<Login />} />

    {/* Protected Routes: Everything inside this block requires the user to be logged in. The <ProtectedRoute /> component checks authentication state. If the user is not logged in, it redirects them to /login. */}
    <Route element={<ProtectedRoute />}>
     {/*Main layout route: The <Main /> component typically includes sidebar, navbar, and an <Outlet /> for nested pages. */}
      <Route path="/" element={<Main />}>
      {/* Default route: Redirect root "/" to the dashboard */}
        <Route index element={<Navigate to="/dashboard" replace />} />

        {/* Dashboard page */}
        <Route path="dashboard" element={<Dashboard />} />
        {/* In-Bond routes */}
        <Route path="in-bond" element={<Inbond/>}/>
        <Route path="/in-bond/add-in-bond" element={<Addinbond/>}/>
        <Route path="/in-bond/edit-in-bond" element={<EditInBond/>}/>
        {/* Ex-Bond routes */}
        <Route path="/ex-bond" element={<Exbond/>}/>
        <Route path="/ex-bond/add-ex-bond" element={<Addexbond/>}/>
        <Route path="/ex-bond/edit-ex-bond" element={<Editexbond/>}/>
        {/* Dispatch Page */}
        <Route path="/dispatch" element={<Dispatch/>}/>
        <Route path="/dispatch/add-dispatch" element={<AddDispatch/>}/>
        <Route path="/dispatch/edit-dispatch" element={<EditDispatch/>}/>
         {/* Material page */}
        <Route path="/material" element={<Material/>}/> 
        {/* Section page */}
        <Route path="/sections" element={<Sections/>}/>
        {/* Duty Calculator page */}
        <Route path="/calculator" element={<Calculator/>}/>
        {/* Duty Space summary page */}
        <Route path="/duty-space" element={<Dutyspace/>}/>
        {/* Customer Page */}
        <Route path="/customer" element={<Customer/>}/>

        {/* Catch-all route: Redirect any unknown path to Dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Route>
   {/* Fallback route: If user is not logged in, redirect all unknown paths to Login */}
    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

export default AppRoutes;
